module.exports = __webpack_public_path__ + "static/media/call-large-40px.e71297e3.svg";